import { Extension } from "@tiptap/core";
import { Plugin, PluginKey, Transaction } from "@tiptap/pm/state";
import { IChecksForUnderstandingContextSubmissions } from "@/types/models/CheckForUnderstandingQuiz.interface";
import { IGuidedHighlightingQuestion } from "@/view/utils/useGuidedHighlightingStudent/types";
import {
  Assignment,
  EmptyAssignment,
} from "@/types/models/Assignment.interface";
import { UserProperties } from "@/types/models/UserProperties.interface";
import { INode } from "@/view/TiptapArticleBody/TiptapArticleBody.interface";
import { IAnnotation } from "@/view/TiptapArticleBody/extensions/TextHighlighting";
import { IContent } from "@/view/utils/useSetInitialLevel";
import { LANG, LANG_EN } from "@/constants/Language";

// TODO: use real types here
export interface IDynamicData {
  setIsReadAloudModeActive: (isActive: boolean) => void;
  addChecksForUnderstandingSubmissions: Function;
  isReadAloudModeActive: boolean;
  assignment: Assignment | EmptyAssignment;
  annotations: IAnnotation[];
  currentFontSize: string;
  media: object;
  levelId: string;
  legacyArticleId: number;
  activeGuidedHighlightingQuestion: IGuidedHighlightingQuestion | undefined;
  checksForUnderstandingSubmissions:
    | IChecksForUnderstandingContextSubmissions
    | undefined;
  checksForUnderstandingQuiz: object;
  isStudentPreviewOn: boolean;
  rawText: INode | null;
  userProperties: UserProperties;
  hasReadAloudInSession: boolean;
  isListenModeActive: boolean;
  activityPanel: string;
  isTranslateMode: boolean;
  content: IContent | undefined;
  language: LANG;
  lexile?: string | undefined;
}

export const dynamicDataPluginKey = new PluginKey("dynamicData");
export const defaultDataState: IDynamicData = {
  setIsReadAloudModeActive: () => null,
  addChecksForUnderstandingSubmissions: () => null,
  isReadAloudModeActive: false,
  assignment: {
    assignment_config: {},
  },
  annotations: [],
  currentFontSize: "small",
  media: {},
  levelId: "",
  legacyArticleId: 0,
  activeGuidedHighlightingQuestion: undefined,
  checksForUnderstandingSubmissions: undefined,
  checksForUnderstandingQuiz: {},
  isStudentPreviewOn: false,
  rawText: null,
  userProperties: {
    canViewPowerWords: false,
    isLiteUser: false,
    isStudent: true,
    isTeacher: false,
  } as unknown as UserProperties,
  hasReadAloudInSession: false,
  isListenModeActive: false,
  activityPanel: "",
  isTranslateMode: false,
  content: undefined,
  language: LANG_EN,
  lexile: undefined,
};

export const dataProviderPlugin = (initialData: IDynamicData) => {
  return new Plugin({
    key: dynamicDataPluginKey,
    state: {
      init: () => {
        return initialData || {};
      },
      apply: (tr: Transaction, previousPluginState) => {
        const meta = tr.getMeta(dynamicDataPluginKey);
        if (meta?.dynamicData !== undefined) {
          return meta.dynamicData;
        }
        return previousPluginState;
      },
    },
  });
};

export const DataProviderExtension = Extension.create({
  name: "dynamicDataExtension",

  addProseMirrorPlugins() {
    return [dataProviderPlugin(defaultDataState)];
  },
});

export default DataProviderExtension;
